// Aftergrow: when the mobile menu drawer closes (Escape or Close), send focus back to the menu
// toggle. Horizon leaves focus on <body> (WCAG 2.4.3 focus order, operator.md 4.5).
(() => {
  const details = document.getElementById('Details-menu-drawer-container');
  if (!details) return;

  details.addEventListener('toggle', () => {
    if (details.open) return;
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    // Leave focus alone if it already moved somewhere else on the page (a click outside the drawer).
    const active = document.activeElement;
    if (active && active !== document.body && !details.contains(active)) return;
    summary.focus({ preventScroll: true });
  });
})();
